module.exports = __webpack_public_path__ + "img/Skirt-Back-B1-Da-Fc-Ga-Hc 后背.346ba79d.png";